import { useCallback, useContext } from 'react';
import { message } from 'antd';
import { AuthContext } from 'shared/context/auth-context';

export default function useHandleUnauthorized() {
  const { logout } = useContext(AuthContext);

  return useCallback(() => {
    logout();
    message.info('Για λόγους ασφαλείας πρέπει να συνδεθείτε ξανά', [5]);
  }, [logout]);
}
